import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../Styles/ReviewBooking.css";
import Navber from '../Components/Navber.jsx';
import api from "../Api.js"
import { showToast } from "./PopupMessage.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";


function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Get parts
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const monthName = months[date.getMonth()];

    // Add ordinal suffix
    const getOrdinal = (n) => {
        if (n % 10 === 1 && n % 100 !== 11) return n + "st";
        if (n % 10 === 2 && n % 100 !== 12) return n + "nd";
        if (n % 10 === 3 && n % 100 !== 13) return n + "rd";
        return n + "th";
    };

    return `${dayName} ${getOrdinal(day)} ${monthName}`;
}
function calculateNights(checkIn, checkOut) {
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);

    // Difference in milliseconds
    const diffTime = outDate - inDate;

    // Convert ms → days
    const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return nights;
}


const ReviewBooking = () => {
    const [policyChecked, setPolicyChecked] = useState(false);

    const [days, setDays] = useState([{ day: 1, value: "" }]);
    const [couponCode, setCouponCode] = useState("")
    const [information, setInformation] = useState(true)
    const [totaldiscount, setTotaldiscount] = useState(0)
    const [applied, setApplied] = useState(false);
    const [profile, setProfile] = useState(false);
    const customer = JSON.parse(localStorage.getItem("customer")) || {};
    const navigate = useNavigate();
    const { bookingID } = useParams();
    console.log("Booking ID from params:", bookingID);
    const location = useLocation();
    const { bookingDetails, hotel, Time } = location.state || {};
    console.log("Booking Details from state:", bookingDetails);
    console.log("Booking Details from state:", hotel);
    const accessToken = localStorage.getItem("accessToken");
    const applyCoupon = async () => {
        try {
            const CouponData = {
                code: couponCode,
                booking_type: "Hotel",
                amount: bookingDetails.total_price
            }
            const response = await api.post("/coupons/validate", CouponData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            console.log("Coupon response: ", response);
            if (response.data.status === true) {
                setTotaldiscount(response?.data?.discount)
                showToast("Coupon Applied Successfully...", "success");
                setApplied(true)
            }


        } catch (err) {
            console.log(err)
        }
    }


    // Payment Integration Part

    const handlePayment = async () => {
          if (!policyChecked) {
    showToast("Please agree to the User Agreement and Policies before proceeding.", "warning");
    return; // stop payment
  }
        // 1. Create order on backend
        try {
            const payload = {
                hotel_room_booking_id: bookingDetails?.id,
                amount: bookingDetails.total_price - totaldiscount,
                currency: "INR",
                payment_type: "advance",
                booking_type: "hotel"
            }
            console.log(payload)
            const order = await api.post(
                "/payments/order", payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${accessToken}`,
                    },
                }
            );




            console.log("order:", order);

            const options = {
                key: order?.data?.key_id, // public key only
                amount: order?.data?.order?.amount,
                currency: order?.data?.order?.currency,
                name: "My React Store",
                description: "Test Transaction",
                order_id: order?.data?.order?.id,
                handler: async function (response) {
                    // send to backend for verification
                    console.log("response,", response);
                    const verifyPayload = {
                        razorpay_order_id: response.razorpay_order_id,     // from Razorpay
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature
                    };
                    console.log("response,", verifyPayload);
                    try {
                        const verifyRes = await api.post("/payments/verify", verifyPayload,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${accessToken}`,
                                },
                            }
                        );
                        console.log("verifyRes:", verifyRes)
                        if (verifyRes?.status === 200) {
                            // alert("Payment Successfully Done!");
                            await api.post("/coupons/apply", {
                                code: couponCode,
                                booking_type: "Hotel",
                                booking_id: bookingDetails?.id,
                                amount: bookingDetails.total_price,
                                discount: totaldiscount
                            }, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${accessToken}`,
                                },
                            }
                        );
                        console.log("verifyRes:", verifyRes)
                        if (verifyRes?.status === 200) {
                            // alert("Payment Successfully Done!");
                            showToast("Payment Successfully Done!", "success")
                            navigate("/profile/hotel-info");
                        } else {
                            alert("Payment verification failed");
                        }
                    }} catch (err) {
                        alert("Error verifying payment");
                        console.log(err)
                    }
                },
                prefill: {
                    name: "Akash Shaikh",
                    email: "akash@example.com",
                    contact: "9999999999",
                },
                theme: {
                    color: "#3399cc",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
            console.log("after payment", rzp)

        } catch (err) {
            console.log(err)
        }


    };

     const profileData = {
    title: "Mr.",
    firstName: customer.name,
    lastName: "Shaikh",
    email: customer.email,
    phone: customer.mobile,
  };

  // initial state: one guest row
  const [guests, setGuests] = useState([
    { title: "", firstName: "", email: "", phone: "", sameAsProfile: false },
  ]);

  // Add a new guest row
  const handleAddGuest = () => {
    setGuests([
      ...guests,
      { title: "", firstName: "", email: "", phone: "", sameAsProfile: false },
    ]);
  };

  // Remove guest row by index
  const handleRemoveGuest = (index) => {
    const newGuests = guests.filter((_, i) => i !== index);
    setGuests(newGuests);
  };

  // Handle input change
  const handleChange = (index, field, value) => {
    const newGuests = [...guests];
    newGuests[index][field] = value;
    setGuests(newGuests);
  };

  // Handle checkbox “Same as Profile Information”
  const handleSameAsProfile = (index, checked) => {
    setProfile(checked);
    const newGuests = [...guests];
    newGuests[index].sameAsProfile = checked;

    if (checked) {
      // copy profile data to inputs
      newGuests[index] = {
        ...newGuests[index],
        ...profileData,
        sameAsProfile: true,
      };
    } else {
      // clear data if unchecked
      newGuests[index] = {
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        sameAsProfile: false,
      };
    }
    setGuests(newGuests);
  };







    return (
        <>
            <div style={{ backgroundColor: "#f0f0f0" }}>
                <Navber />
            </div>
            <div className="reviewBooking-container">
                <div className="reviewBooking-title">Review your Booking</div>

                <div className="reviewBooking-main">
                    {/* Left Section */}
                    <div className="reviewBooking-left">
                        {/* Hotel Details */}
                        <div className="reviewBooking-card animate-fadeIn">
                            <h3 className="hotel-title">{hotel?.name}</h3>
                            <div className="hotel-stars">★★★★★</div>
                            <p className="hotel-address">
                                {hotel?.land_mark},{hotel?.location}
                            </p>

                            <div className="checkin-checkout">
                                <div>
                                    <p style={{ margin: "0" }}>CHECK IN</p>
                                    <strong>{formatDate(bookingDetails.check_in)}</strong>
                                    <p style={{ margin: "0" }}>{dayjs(Time?.check_in).format("hh:mm A")}</p>
                                </div>
                                <div>
                                    <p style={{ margin: "0" }}>CHECK OUT</p>
                                    <strong>{formatDate(bookingDetails.check_out)}</strong>
                                    <p style={{ margin: "0" }}>{dayjs(Time?.check_out).format("hh:mm A")}</p>
                                </div>
                                <div className="booking-summary">
                                    <p style={{ margin: "0" }}> {calculateNights(bookingDetails.check_in, bookingDetails.check_out)} night | {bookingDetails.adults} Adults | 1 Room</p>
                                    <p style={{ margin: "0" }}>Total Guest:{bookingDetails.total_guests} </p>
                                </div>
                            </div>

                            <div className="room-info">
                                {/* <h4>Joint Cottage</h4>
                                <ul>
                                    <li>2 Adults</li>
                                    <li>Swimming Pool</li>
                                    <li>Lounge</li>
                                    <li>Kids Play Area</li>
                                    <li>Power Backup</li>
                                </ul> */}
                                {/* <p className="non-refundable">Non-Refundable</p>
                                <small>
                                    <br />
                                    Date change allowed once without penalty (until 24 hrs before check-in)
                                </small> */}
                            </div>
                        </div>

                        {/* Important Info */}
                        <div className="reviewBooking-card animate-slideUp">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }} onClick={() => setInformation(!information)}>
                                <span style={{ fontWeight: "600" }}>Important Information</span>
                                {information ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}

                            </div>
                            {information ?
                                <ul style={{ transition: "2s" }}>
                                    <li>Primary Guest should be atleast 18 years of age.</li>
                                    <li>Passport, Aadhaar and Driving License are accepted as ID proof(s)</li>
                                    <li>Pets are not allowed</li>
                                    <li>
                                        Optional: Fee for buffet breakfast: INR 500 for adults and INR 350 for
                                        children (approx.)
                                    </li>
                                    <li>Airport Shuttle fee: INR 1500 per vehicle (one way)</li>
                                    <li>Early check-in fee: INR 1000 (subject to availability)</li>
                                    <li>Late check-out fee: INR 1000 (subject to availability)</li>
                                    <li>Refund is not applicable for this booking </li>
                                    <li>Date change allowed once without penalty (until 24 hrs before check-in)</li>
                                </ul> : ""}


                        </div>

                        {/* Guest Info */}
                        <div className="reviewBooking-card animate-fadeIn">
                            <h4>Guest Information</h4>

                                                                <label style={{ display: "block", marginBottom: "0.5rem" }}>
                                        <input
                                            type="checkbox"
                                            checked={profile}
                                            onChange={(e) => handleSameAsProfile(0, e.target.checked)}
                                        />{" "}
                                        Same as Profile Information
                                    </label>

                            {guests.map((guest, index) => (
                                <div key={index} className="guest-form" style={{ marginBottom: "1rem" }}>


                                    <select
                                        value={guest.title}
                                        onChange={(e) => handleChange(index, "title", e.target.value)}
                                    >
                                        <option value="">Select Title</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                    </select>

                                    <input
                                        type="text"
                                        placeholder="Name"
                                        value={guest.firstName}
                                        onChange={(e) => handleChange(index, "firstName", e.target.value)}
                                    />
                                    <input
                                        type="email"
                                        placeholder="Enter email address"
                                        value={guest.email}
                                        onChange={(e) => handleChange(index, "email", e.target.value)}
                                    />
                                    <input
                                        type="tel"
                                        placeholder="Enter phone number"
                                        value={guest.phone}
                                        onChange={(e) => handleChange(index, "phone", e.target.value)}
                                    />

                                    {guests.length > 1 && (
                                        <button
                                            type="button"
                                            className="remove-guest-btn"
                                            onClick={() => handleRemoveGuest(index)}
                                        >
                                            Remove
                                        </button>
                                    )}
                                </div>
                            ))}

                            <button type="button" className="add-guest-btn" onClick={handleAddGuest}>
                                + Add Guest
                            </button>
                        </div>

                        {/* Agreement */}
<div className="terms-section">
  <label>
    <input
      type="checkbox"
      checked={policyChecked}
      onChange={(e) => setPolicyChecked(e.target.checked)}
    />{" "}
    By proceeding, I agree to Jayraj Group’s{" "}
    <span
      onClick={() => navigate("/user-agreement")}
      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
    >
      User Agreement
    </span>
    ,{" "}
    <span
      onClick={() => navigate("/terms-of-services")}
      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
    >
      Terms of Service
    </span>{" "}
    and{" "}
    <span
      onClick={() => navigate("/cancellation-policy")}
      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
    >
      Cancellation & Property Booking Policies
    </span>
    .
  </label>
</div>




                        <div className="pay-now-btn">
                            <span className="pay-now-btn-price" >₹{Math.ceil(bookingDetails.total_price - totaldiscount)}</span><button onClick={handlePayment}>Pay Now</button>
                        </div>

                    </div>

                    {/* Right Section */}
                    <div className="reviewBooking-right">
                        <div className="reviewBooking-card animate-slideUp">
                            <h4>Price Breakup</h4>
                            <ul className="price-breakup">
                                <li style={{ display: "flex", justifyContent: "space-between" }}><span>1 room x 1 night</span><span>{Math.ceil(bookingDetails.total_price / bookingDetails.total_guests)}</span></li>
                                <li style={{ display: "flex", justifyContent: "space-between" }}><span>Total Discount</span><span>{totaldiscount}</span></li>
                                <li style={{ display: "flex", justifyContent: "space-between" }}><span>Price After Discount</span><span>{Math.ceil(bookingDetails.total_price / bookingDetails.total_guests)-totaldiscount}</span></li>
                                <li style={{ display: "flex", justifyContent: "space-between" }}><span>Taxes & Service Fees</span><span>0</span></li>
                                <li style={{ display: "flex", justifyContent: "space-between", fontWeight: "600" }}><span>Total Amount</span><span></span>{Math.ceil(bookingDetails.total_price - totaldiscount)}</li>
                               

                            </ul>
                        </div>

                        <div className="reviewBooking-card animate-fadeIn">
                            <h4>Coupon Codes</h4>
                            <div className="reviewBooking-card-input-container">
                                <input type="text" placeholder="Enter Your Coupon Code here" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
                                <button onClick={applyCoupon} disabled={applied}>{applied ? "Applied" : "Apply"}</button>
                            </div>

                        </div>
                    </div>
                    {/* Agreement */}
                    <div className="terms-section" id="terms-section-id">
                        <label>
                            <input type="checkbox" /> By proceeding, I agree to Jayraj Group’s{" "}
                            <span onClick={()=>navigate("/user-agreement")} style={{color:"blue",cursor:"pointer",textDecoration:"underline"}}>User Agreement</span>, <span onClick={()=>navigate("/terms-of-services")} style={{color:"blue",cursor:"pointer",textDecoration:"underline"}}>Terms of Service</span> and{" "}
                            <span onClick={()=>navigate("/cancellation-policy")} style={{color:"blue",cursor:"pointer",textDecoration:"underline"}}>Cancellation & Property Booking Policies</span>.
                        </label>
                    </div>
                </div>
            </div >
        </>

    );
};

export default ReviewBooking;
